// extracted by mini-css-extract-plugin
export default {"title":"MatchingTable_title__3af3S","container":"MatchingTable_container__oYSHD"};